/**
 * PDF base64 del contrato → bytes para react-pdf.
 * No crea un object URL.
 */
export function decodePdfBase64(file) {
  const raw = String(file || '')
    .replace(/^data:application\/pdf;base64,/i, '')
    .replace(/\s/g, '');
  if (!raw) return new Uint8Array();
  const binary = atob(raw);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return bytes;
}
